// extracted by mini-css-extract-plugin
export default {"mainContainer":"UploadTenants_mainContainer__A-8K6","uploadTenantsFileContainer":"UploadTenants_uploadTenantsFileContainer__gza9d","title":"UploadTenants_title__UXicO"};